import { Component, HostListener, OnInit, Output, EventEmitter } from '@angular/core';
import { AutenticacaoService } from '../../autenticacao/autenticacao.service';
import { trigger, state, style, animate, transition } from '@angular/animations';

export interface RouteInfo {
  path?: string;
  title: string;
  icon?: string;
  class?: string;
  items?: RouteInfo[];
  initials?: string;
  visivel?: boolean;
}

export const expandCollapseAnimation = trigger('expandCollapse', [
  state('collapsed', style({ height: '0', opacity: '0', overflow: 'hidden', transform: 'scaleY(0)' })),
  state('expanded', style({ height: '*', opacity: '1', overflow: 'hidden', transform: 'scaleY(1)' })),
  transition('collapsed <=> expanded', animate('400ms ease-in-out')),
]);

export const ROUTES: RouteInfo[] = [
  {
    title: 'Processo',
    icon: 'pi pi-book',
    items: [{ path: '/processo/listar', title: 'Listagem' }],
  },
  {
    title: 'Arquivo',
    icon: 'pi pi-file',
    items: [{ path: '/arquivo/exportarTextos', title: 'Exportar textos' }],
  },
  {
    title: 'Fontes de dados',
    icon: 'pi pi-cloud',
    items: [
      { path: '/fonteDados/listar', title: 'Listagem' },
      { path: '/fonteDados/monitor', title: 'Monitoramento' },
    ],
  },
  {
    title: 'Mensageria',
    icon: 'pi pi-envelope',
    items: [
      { path: '/mensagemControle/listar', title: 'Listar Mensagens' },
      { path: '/mensagemControle/executarPendentes', title: 'Mensagens Pendentes' },
    ],
  },
  {
    title: 'Manutenção',
    icon: 'pi pi-wrench',
    items: [
      { path: '/manutencao/sincronizarProcessos', title: 'Sincronizar processos' },
      { path: '/manutencao/sincronizarProcessosAssociacoes', title: 'Sincronizar associações' },
      { path: '/manutencao/processarDocumentos', title: 'Processar documentos' },
      { path: '/manutencao/reprocessarDocumentos', title: 'Reprocessar documentos' },
    ],
  },
  {
    title: 'Administração',
    icon: 'pi pi-key',
    items: [
      { path: '/assunto/listar', title: 'Assunto' },
      { path: '/cep/listar', title: 'Cep' },
      { path: '/localidade/listar', title: 'localidade' },
      { path: '/unidadeFederativa/listar', title: 'UF' },
      { path: '/pais/listar', title: 'País' },
      { path: '/classe/listar', title: 'Classe' },
      { path: '/competencia/listar', title: 'Competência' },
      { path: '/indisponibilidade/listar', title: 'Indisponibilidade' },
      { path: '/jurisdicao/listar', title: 'Jurisdição' },
      { path: '/jurisdicaoLocal/listar', title: 'Jurisdição Local' },
      { path: '/modelo/listar', title: 'Modelo' },
      { path: '/orgaoJulgador/listar', title: 'Orgãos julgadores' },
      { path: '/orgaoJulgadorLocal/listar', title: 'Orgãos julgadores locais' },
      { path: '/orgaoJulgadorColegiadoLocal/listar', title: 'Orgãos colegiados locais' },
      { path: '/orgaoJustica/listar', title: 'Orgãos da Justiça' },
      { path: '/parametro/listar', title: 'Parâmetro' },
      { path: '/pessoa/listar', title: 'Pessoa' },
      { path: '/particionamento/listar', title: 'Particionamento' },
      { path: '/tipoMovimento/listar', title: 'Tipo Movimento' },
      { path: '/tipoComplemento/listar', title: 'Tipo Complemento' },
      { path: '/tipoParte/listar', title: 'Tipo Parte' },
      { path: '/tipoProcessoDocumento/listar', title: 'Tipo processo documento' },
      { path: '/usuario/listar', title: 'Usuário' },
      { path: '/usuarioPermissao/listar', title: 'Usuário Permissões' },
      { path: '/perfil/listar', title: 'Perfil Segurança' },
      { path: '/recursoSeguranca/listar', title: 'Recurso Segurança' },
    ],
  },
  {
    title: 'Auditoria',
    icon: 'pi pi-user',
    items: [
      { path: '/pessoaAuditoriaAcesso/listar', title: 'Pessoa Auditoria Acesso' },
      { path: '/processoAuditoriaAcesso/listar', title: 'Processo Auditoria Acesso' },
    ],
  },
];

ROUTES.forEach((menuItem) => {
  if (menuItem.items !== undefined) {
    menuItem.items.forEach((subItem) => {
      const splitted = subItem.title.split(' ', 3);
      subItem.initials = splitted.map((palavra) => palavra.substr(0, 1)).reduce((a, b) => a + b);
      subItem.visivel = false;
    });
  }
  menuItem.visivel = false;
});

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  animations: [expandCollapseAnimation],
})
export class SidebarComponent implements OnInit {
  @Output()
  listaDeRotas: EventEmitter<RouteInfo[]> = new EventEmitter();

  public menuItems = ROUTES;
  public mobileMenu = true;
  public carregandoMenu = true;
  public itensAbertos = new Set<number>();

  constructor(private autenticacaoService: AutenticacaoService) {}

  ngOnInit(): void {
    this.autenticacaoService.getAutenticacaoObservable().subscribe(() => this.processarMenuItems());
    this.processarMenuItems();
    this.checkWindowsWidth();
  }

  private processarMenuItems(): void {
    this.carregandoMenu = true;

    if (this.autenticacaoService.isAutenticado()) {
      this.menuItems.forEach((menuItem) => {
        if (menuItem.items) {
          let temFilhoVisivel = false;

          menuItem.items.forEach((subItem) => {
            if (subItem.path) {
              subItem.visivel = this.autenticacaoService.temPermissaoAcesso(subItem.path);
            }

            if (subItem.visivel) {
              temFilhoVisivel = true;
            }
          });

          menuItem.visivel = temFilhoVisivel;
        } else if (menuItem.path) {
          menuItem.visivel = this.autenticacaoService.temPermissaoAcesso(menuItem.path);
        }
      });

      this.carregandoMenu = false;
    } else {
      this.menuItems.forEach((menuItem) => {
        menuItem.visivel = false;
      });
      this.carregandoMenu = false;
    }

    this.listaDeRotas.emit(this.menuItems);
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize(): void {
    this.checkWindowsWidth();
  }

  private checkWindowsWidth(): void {
    if (window.innerWidth > 991) {
      this.mobileMenu = false;
      this.sidebarToggle();
    } else {
      this.mobileMenu = true;
      this.sidebarToggle();
    }
  }

  public temUsuarioAutenticado(): boolean {
    return this.autenticacaoService.isAutenticado();
  }

  sidebarToggle() {
    const sidebar = document.getElementsByClassName('sidebar')[0];

    if (this.mobileMenu) {
      if (this.getSidebarVisible()) {
        sidebar.classList.remove('hidden');
      } else {
        sidebar.classList.add('hidden');
      }
    } else {
      sidebar.classList.remove('hidden');
    }
  }

  private getSidebarVisible() {
    return Boolean(JSON.parse(localStorage.getItem('sidebarVisible') || ''));
  }

  public abrirMenu(index: number): void {
    if (this.itensAbertos.has(index)) {
      this.itensAbertos.delete(index);
    } else {
      this.itensAbertos.add(index);
    }
  }
  public estaAberto(index: number): boolean {
    return this.itensAbertos.has(index);
  }
}
